// this file is imported both from server & client code
// client code gets it's config from the `window.__WOT__` object which is assigned `on layout.pug` file
// server code gets it's config from the server process env

module.exports = typeof window !== 'undefined' && window.__WOT__ ? window.__WOT__.config : {};
